export function getReportIncludeLabel(metadata) {
  if (!metadata || !Object.hasOwn(metadata, "invoicedOnly")) return null;
  if (typeof metadata.invoicedOnly !== "boolean") {
    throw Object.assign(new Error("Report Include context must be an explicit boolean."), {
      status: 400, code: "REPORT_INCLUDE_INVALID",
    });
  }
  return metadata.invoicedOnly ? "Include: Invoiced time only" : "Include: All time";
}
